export default __webpack_public_path__ + "media/MarketplaceLogo.b41cbbe8329bdab6ba6d3334fa7bf128.svg";